// Credenciales fijas de acceso, iguales para box y router.
const DEFAULT_USER = 'kiconex';
const DEFAULT_PASSWORD = '00#Kiconex';

// IP de acceso por modelo de box. Los modelos no listados no tienen IP conocida.
const BOX_IP_BY_MODEL = {
  Box0:  '192.168.0.1:8080',
  Box1A: '192.168.0.1:8080',
  Box2A: '192.168.0.1:8080',
  Box2:  '100.100.100.100',
  Box4:  '100.100.100.100',
};

/**
 * Esquema único de columnas del Excel de asignados.
 * Cada columna resuelve su valor para los dos tipos de fila.
 */
const EXPORT_COLUMNS = [
  {
    label: 'UUID',
    box:    (box) => box.uuid,
    router: (box) => 'RUT-' + box.uuid,
  },
  {
    label: 'SN',
    box:    (box) => box.serial_number,
    router: (box, router) => router.modem_serial_number ?? '',
  },
  {
    label: 'MAC',
    box:    (box) => (box.model_name === 'Box1A' ? '' : box.physical_id),
    router: (box, router) => router.modem_mac ?? '',
  },
  {
    label: 'VERSION',
    box:    (box) => `${box.model_name} ${box.version_name}`,
    router: (box, router) => `${router.model_name} ${router.version_name}`,
  },
  {
    label: 'IP',
    box:    (box) => BOX_IP_BY_MODEL[box.model_name] ?? 'No data',
    router: () => '192.168.0.1:8080',
  },
  {
    label: 'USUARIO',
    box:    () => DEFAULT_USER,
    router: () => DEFAULT_USER,
  },
  {
    label: 'CONTRASEÑA',
    box:    () => DEFAULT_PASSWORD,
    router: () => DEFAULT_PASSWORD,
  },
];

const buildBoxRow = (box) => {
  const row = {};
  EXPORT_COLUMNS.forEach(col => { row[col.label] = col.box(box); });
  return row;
};

const buildRouterRow = (box, router) => {
  const row = {};
  EXPORT_COLUMNS.forEach(col => { row[col.label] = col.router(box, router); });
  return row;
};

/**
 * Construye las filas del Excel de kibox asignados.
 * Por cada box seleccionado emite su fila y, si tiene un router enlazado,
 * otra fila para el router justo debajo.
 *
 * @param {Array<Object>} selectedBoxes Filas enriquecidas de los box seleccionados
 * @param {Array<Object>} routers Lista de routers en estado Asignado
 * @returns {Array<Object>|null} Las filas, o null si algún router no se resuelve
 */
export function buildKiboxAssignedExportRows(selectedBoxes, routers = []) {

  const routerByUuid = new Map(routers.map(router => [router.uuid, router]));
  const rows = [];

  for (const box of selectedBoxes) {
    rows.push(buildBoxRow(box));

    if (!box.router_uuid) continue;

    const router = routerByUuid.get(box.router_uuid);

    // Sin el router no se puede completar el equipo: se cancela la exportación.
    if (!router) return null;

    rows.push(buildRouterRow(box, router));
  }

  return rows;
}
